// تبدیلِ base64 برای آپلود — تنها بخشِ این فایل که پلتفرم‌مستقل بود.
// انتخابِ عکس از گالری (expo-image-picker) موبایل‌محضه؛ نگاه کن به
// apps/mobile/src/native/imagePicker.ts.
import { decode, encode } from 'base64-arraybuffer';

/**
 * base64 خام (بدون پیشوند `data:`) → ArrayBuffer برای آپلود به Supabase Storage.
 *
 * حتماً ArrayBuffer بمونه، نه Uint8Array و نه رشته: توی ری‌اکت‌نیتیو، بدنه‌ی
 * درخواستِ fetch اگه Uint8Array باشه یا خالی می‌ره یا خطا می‌خوره. این تنها شکلیه
 * که خودِ Supabase هم برای ری‌اکت‌نیتیو مستندش کرده.
 * `atob` هم عمداً استفاده نمیشه — روی همه‌ی موتورهای جاوااسکریپتِ RN نیست.
 */
export const base64ToArrayBuffer = (b64: string): ArrayBuffer => decode(b64);

/**
 * راهِ برگشت: ArrayBuffer → base64 خام.
 *
 * برای **ذخیره‌ی** عکس روی دستگاه لازم است (WHOSUP-213): آدرسِ امضاشده را
 * می‌گیریم و بایت‌هایش را باید به فایل بنویسیم، و تنها قالبی که
 * `expo-file-system` برای نوشتنِ داده‌ی دودویی می‌پذیرد base64 است.
 *
 * `btoa` عمداً استفاده نمی‌شود — همان دلیلِ `atob` بالا: روی همه‌ی موتورهای
 * جاوااسکریپتِ ری‌اکت‌نیتیو نیست.
 */
export const arrayBufferToBase64 = (buf: ArrayBuffer): string => encode(buf);
